import { Dispatch, useCallback } from 'react';
import { useRouter } from '../../hooks/useRouter';
import { useBrowser } from '../../services/BrowserService';
import { SuggestionData } from './Suggestions/types';
import { useSearchFilters } from './filters/useSearchFilters';

export const useSuggestionHandler = () => {
  const [, setFilters] = useSearchFilters();
  const router = useRouter();
  const { window } = useBrowser();
  const doc = window?.document;
  const bodyClassList = doc?.body?.classList;
  const bannerOn = bodyClassList?.contains('branch-banner-is-active') ? true : false;

  const initAndCloseBannerFromHomepage = useCallback(async () => {
    if (bannerOn) {
      window?.branch?.closeJourney(err => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
    }
  }, [window?.branch, bannerOn]);

  const handleSuggestion: Dispatch<SuggestionData> = useCallback(
    suggestion => {
      switch (suggestion.type) {
        case 'PracticeSuggestion':
          //close journey banner before routing to practice profile
          void initAndCloseBannerFromHomepage();
          void router?.push(suggestion.practice.url);
          break;

        case 'PractitionerSuggestion':
          void router?.push(suggestion.practitioner.url);
          break;

        case 'TextSuggestion':
          setFilters(suggestion.filters);
          break;

        case 'FilterSuggestion':
          setFilters(suggestion.filters);
          break;
      }
    },
    [router, setFilters, initAndCloseBannerFromHomepage],
  );

  return handleSuggestion;
};
